import { useEffect, useMemo, useState } from 'react';

export const useElementSize = (element?: Element | null) => {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  const resizeObserver = useMemo(
    () =>
      new ResizeObserver(entries => {
        for (const entry of entries) {
          setHeight((entry.target as HTMLElement).offsetHeight);
          setWidth((entry.target as HTMLElement).offsetWidth);
        }
      }),
    [],
  );

  useEffect(() => {
    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
    };
  }, [element, resizeObserver]);

  return {
    width,
    height,
  };
};
